import { TFunction } from 'react-i18next'

const prefix = 'configuration.userProfile.tabs'
const prefixAdvance = 'configuration.userProfile.advance'
const prefixReusable = 'reusable'

export const translations = (t: TFunction) => ({
  configuration: {
    userProfile: {
      tabs: {
        courses: {
          rowsCount: t(`${prefix}.courses.rowsCount`),
          rowsCountPlural: t(`${prefix}.courses.rowsCountPlural`),
          header: {
            title: t(`${prefix}.courses.header.title`),
            description: t(`${prefix}.courses.header.description`),
          },
          name: t(`${prefix}.courses.name`),
          profiles: t(`${prefix}.courses.profiles`),
          mandatory: {
            title: t(`${prefix}.courses.mandatory.title`),
            required: t(`${prefix}.courses.mandatory.required`),
            optional: t(`${prefix}.courses.mandatory.optional`),
          },
          type: t(`${prefix}.courses.type`),
          advance: t(`${prefix}.courses.advance`),
          approvalStatus: t(`${prefix}.courses.approvalStatus`),
          period: t(`${prefix}.courses.period`),
          emptyState: {
            noMatches: t(`${prefix}.courses.emptyState.noMatches`),
            noCourses: t(`${prefix}.courses.emptyState.noCourses`),
          },
          actions: {
            viewResults: t(`${prefix}.courses.actions.viewResults`, {
              defaultValue: 'Ver resultados',
            }),
            resetCourse: t(`${prefix}.courses.actions.resetCourse`, {
              defaultValue: 'Reiniciar curso',
            }),
          },
        },
        certificates: {
          rowsCount: t(`${prefix}.certificates.rowsCount`),
          rowsCountPlural: t(`${prefix}.certificates.rowsCountPlural`),
          header: {
            title: t(`${prefix}.certificates.header.title`),
            description: t(`${prefix}.certificates.header.description`),
          },
          name: t(`${prefix}.certificates.name`),
          certificateType: t(`${prefix}.certificates.certificateType`),
          certificateTypeIndividual: t(
            `${prefix}.certificates.certificateTypeIndividual`
          ),
          certificateTypeGroup: t(
            `${prefix}.certificates.certificateTypeGroup`
          ),
          obtainedDate: t(`${prefix}.certificates.obtainedDate`),
          coursesCount: t(`${prefix}.certificates.coursesCount`, {
            defaultValue: '{{count}} cursos',
          }),
          coursesModal: {
            title: t(`${prefix}.certificates.coursesModal.title`, {
              defaultValue: 'Cursos asociados',
            }),
            close: t(`${prefix}.certificates.coursesModal.close`, {
              defaultValue: 'Cerrar',
            }),
            headers: {
              name: t(`${prefix}.certificates.coursesModal.headers.name`, {
                defaultValue: 'Nombre del curso',
              }),
            },
            restrictedCourse: t(
              `${prefix}.certificates.coursesModal.restrictedCourse`,
              { defaultValue: '{{count}} cursos sin acceso' }
            ),
            alert: t(`${prefix}.certificates.coursesModal.alert`, {
              defaultValue:
                'Este certificado tiene {{total}} cursos, de los cuales no tienes acceso a {{restricted}}.',
            }),
            rowsCount: t(`${prefix}.certificates.coursesModal.rowsCount`, {
              defaultValue: 'curso',
            }),
            rowsCountPlural: t(
              `${prefix}.certificates.coursesModal.rowsCountPlural`,
              { defaultValue: 'cursos' }
            ),
          },
          mandatory: {
            title: t(`${prefix}.certificates.mandatory.title`),
            required: t(`${prefix}.certificates.mandatory.required`),
            optional: t(`${prefix}.certificates.mandatory.optional`),
          },
          type: t(`${prefix}.certificates.type`),
          download: t(`${prefix}.certificates.download`),
          downloadSelectedCertificates: t(
            `${prefix}.certificates.downloadSelectedCertificates`
          ),
          notifications: {
            download: t(`${prefix}.certificates.notifications.download`),
            downloadSelected: t(
              `${prefix}.certificates.notifications.downloadSelected`
            ),
          },
          emptyState: {
            noMatches: t(`${prefix}.certificates.emptyState.noMatches`),
            noCertificates: t(
              `${prefix}.certificates.emptyState.noCertificates`
            ),
          },
        },
        legalAttestations: {
          rowsCount: t(`${prefix}.legalAttestations.rowsCount`),
          rowsCountPlural: t(`${prefix}.legalAttestations.rowsCountPlural`),
          header: {
            title: t(`${prefix}.legalAttestations.header.title`),
            description: t(`${prefix}.legalAttestations.header.description`),
          },
          courseName: t(`${prefix}.legalAttestations.courseName`),
          obtainedDate: t(`${prefix}.legalAttestations.obtainedDate`),
          download: t(`${prefix}.legalAttestations.download`),
          tooltips: {
            missingAttestation: t(
              `${prefix}.legalAttestations.tooltips.missingAttestation`
            ),
            incompleteProfile: t(
              `${prefix}.legalAttestations.tooltips.incompleteProfile`
            ),
          },
          notifications: {
            download: t(`${prefix}.legalAttestations.notifications.download`),
          },
          emptyState: {
            noAttestations: t(
              `${prefix}.legalAttestations.emptyState.noAttestations`
            ),
            noAttestationsDescription: t(
              `${prefix}.legalAttestations.emptyState.noAttestationsDescription`
            ),
          },
        },
      },
      advance: {
        title: t(`${prefixAdvance}.title`),
        allCourses: t(`${prefixAdvance}.allCourses`),
        finished: t(`${prefixAdvance}.finished`),
        inProgress: t(`${prefixAdvance}.inProgress`),
        notStarted: t(`${prefixAdvance}.notStarted`),
        certificates: t(`${prefixAdvance}.certificates`),
      },
    },
  },
  reusable: {
    mandatoryCourse: {
      required: t(`${prefixReusable}.mandatoryCourse.required`),
      mandatory: t(`${prefixReusable}.mandatoryCourse.mandatory`),
      optional: t(`${prefixReusable}.mandatoryCourse.optional`),
    },
    advance: {
      notStarted: t(`${prefixReusable}.advance.notStarted`),
      inProgress: t(`${prefixReusable}.advance.inProgress`),
      finished: t(`${prefixReusable}.advance.finished`),
    },
    courseApproval: {
      inProgress: t(`${prefixReusable}.courseApproval.inProgress`),
      approved: t(`${prefixReusable}.courseApproval.approved`),
      reproved: t(`${prefixReusable}.courseApproval.reproved`),
    },
    courseType: {
      selfGuided: t(`${prefixReusable}.courseType.selfGuided`),
      synchronousExternal: t(
        `${prefixReusable}.courseType.synchronousExternal`
      ),
      synchronousPresencial: t(
        `${prefixReusable}.courseType.synchronousPresencial`
      ),
      external: t(`${prefixReusable}.courseType.external`),
    },
  },
})
